




















































































































































































































































































































































































import {
  apiActivityVirtualActivityFindUserIntegralCoupon,
  apiGroupBuyingTradePreOrder,
  apiGroupBuyingTradeTradeOrder,
  ApiMerchantStoreQueryWriteOffStoreListResponse,
  apiOrderExchangeGoodsExchangeGoodsPreOrder,
  ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest,
  apiOrderExchangeGoodsExchangeGoodsTrade,
  apiOrderOrderGetUserInfo,
  apiTradeGeneralActCouponTradeIntegralJoinTrade,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
  ApiTradeGeneralTradePreOrderResponse,
  apiTradeGeneralTradeTradeOrder,
  apiTradeSecKillTradeSeckillConfirmResult,
  apiTradeSecKillTradeSeckillTradeOrder,
} from '@/api'
import { computed, ref, watch } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useHistory, useQuery } from '@/hooks'
// import { Dialog } from 'vant'
import { globalModel } from '@/model'
import { isPossibleChineseMobilePhoneNumber, loopUntil, wait } from 'vtils'
import { mall } from '@/mall_jssdk'
import { navigateTo, redirectTo } from '@/router'
import { onPageVisibilityChange } from '@/utils'
import {
  prepareData,
  requestPayment,
  requiredDeep,
  showDialog,
  showSafeKeyboard,
  submit,
  Track,
} from '@/utils'
import { RequiredDeep } from 'vtils/types'
import { useBus } from '../mart/use_bus'
import { UserUtils } from '@/views/user/utils'
import { XPickCouponParams, XPickCouponResult } from '@/components'
import { yup } from 'vtils/validator'

interface PointsDataType {
  integralDiscountAmt?: number
  [propName: string]: any
  // 其他可能的属性
}

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '提交订单',
        }))

        watch(
          () => this.count.value,
          () => {
            this.realUserData.value = this.realUserData.value.slice(
              0,
              this.count.value,
            )
            for (
              let i = this.realUserData.value.length;
              i < this.count.value;
              i++
            ) {
              this.realUserData.value.push({
                name: '',
                phone: '',
                idCard: '',
              })
            }
          },
          {
            immediate: true,
          },
        )

        // 优惠券不能与渠道积分共存
        watch(
          () => [
            this.pickCouponResult.value,
            // 数量变更后清空渠道积分
            this.count.value,
          ],
          () => {
            if (this.pickCouponResult.value.couponId) {
              this.channelPointIndex.value = null as any
              this.channelPointDiscount.value = 0
            }
          },
          {
            immediate: true,
          },
        )

        // 数量变更后清空渠道积分
        watch(
          () => this.count.value,
          () => {
            this.channelPointIndex.value = null as any
            this.channelPointDiscount.value = 0
          },
          {
            immediate: true,
          },
        )

        // 渠道积分不能与优惠券共存
        watch(
          () => this.channelPointIndex.value,
          () => {
            if (this.channelPointIndex.value != null) {
              this.pickCouponResult.value = {} as any
            }
          },
          {
            immediate: true,
          },
        )
        // 监听实际金额更改触发消费金补贴修改
        watch(
          () => this.payAmount.value,
          val => {
            if (!val) {
              return
            }

            setTimeout(() => {
              if (this.query.preOrderResponseData.supportPayType) {
                this.findUserIntegralCoupon()
              }
            }, 1000)
          },
          {
            immediate: true,
            deep: true,
          },
        )

        const off = onPageVisibilityChange(async visible => {
          if (visible) {
            off()
            setTimeout(() => {
              this.dataInit()
            }, 1000)
          }
        })
      }

      query = useQuery<{
        /** 类型 */
        type?: 'groupBuying' | 'dcd'
        /** 兑换商品 */
        sourceType?: 'exchange' | undefined
        /** 预下单请求数据 */
        preOrderRequestData: ApiTradeGeneralTradePreOrderRequest
        /** 预下单请求数据 */
        preOrderRequestData1: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest
        /** 预下单响应数据 */
        preOrderResponseData: ApiTradeGeneralTradePreOrderResponse
      }>({
        preOrderRequestData: {
          transformer: JSON.parse,
        },
        preOrderRequestData1: {
          transformer: JSON.parse,
        },
        preOrderResponseData: {
          transformer: JSON.parse,
        },
      })

      isGroupBuying = computed(() => this.query.type === 'groupBuying')
      isExchange = computed(() => this.query.sourceType === 'exchange')

      isDcd = computed(() => this.query.type === 'dcd')

      isSeckill = computed(
        () => +this.query.preOrderRequestData.preOrderType === 3,
      )

      orderDate = computed(
        () => this.query.preOrderRequestData.skuInfo[0].stockDate,
      )

      count = useHistory(1)

      isFirst = ref(true)

      apiData = useApi(
        async () => {
          const { preOrderData, userData, userInfo } = await prepareData({
            preOrderData: this.isGroupBuying.value
              ? (apiGroupBuyingTradePreOrder({
                  ...this.query.preOrderRequestData,
                  skuInfo: [
                    {
                      ...this.query.preOrderRequestData.skuInfo[0],
                      count: this.count.value,
                    },
                  ],
                } as any) as any as Promise<
                  RequiredDeep<ApiTradeGeneralTradePreOrderResponse>
                >)
              : this.isSeckill.value
              ? Promise.resolve(
                  this.query
                    .preOrderResponseData as RequiredDeep<ApiTradeGeneralTradePreOrderResponse>,
                )
              : this.isExchange.value
              ? apiOrderExchangeGoodsExchangeGoodsPreOrder({
                  ...this.query.preOrderRequestData1,
                }).then(requiredDeep)
              : apiTradeGeneralTradePreOrder({
                  ...this.query.preOrderRequestData,
                  skuInfo: [
                    {
                      ...this.query.preOrderRequestData.skuInfo[0],
                      count: this.count.value,
                    },
                  ],
                }).then(requiredDeep),
            userData: UserUtils.getInfo(),
            userInfo: apiOrderOrderGetUserInfo({}).then(requiredDeep),
          })
          this.phoneNumber.value =
            this.phoneNumber.value || userData.phoneNum || ''

          // if (
          //   preOrderData.supportPayType &&
          //   router.currentRoute.name === 'BookOrderPlace' &&
          //   this.isFirst.value
          // ) {
          //   this.isFirst.value = false
          //   Dialog.alert({
          //     confirmButtonText: '同意并知晓',
          //     confirmButtonColor: '#45A168',
          //     className: 'subsidyPopup',
          //     message:
          //       '该商品参与适老化补贴活动，请您收到货后，拍摄清晰产品图并附带相机水印时间，将照片上传至订单评论区，且享受补贴资格的消费者需配合平台或商家不定期回访，请务必配合，对发现存在利用不正当手段挪用、骗取套取补贴资金的企业和个人(包括伪造、变造相关材料虚假交易、串通他人提供虚假信息等)，平台有权追回产品及补贴，并依法依规严肃处理，涉嫌犯罪的移送司法机关追究刑事责任。',
          //   })
          // }

          return { ...preOrderData, userInfo }
        },
        {
          refreshOnChange: () => this.count.value,
          onError: () => this.count.rollback(),
        },
      )

      preOrderData = computed(() => this.apiData.data)

      orderData = computed(() => this.preOrderData.value.orderInfo[0])

      storeData = computed(() => this.preOrderData.value)

      goodsData = computed(() => this.orderData.value.commodityInfo[0])

      refundData = computed(() => this.orderData.value?.writeOffRefund)

      secondUserInfo = ref({})

      userInfo = computed(() =>
        this.secondUserInfo.value?.authName
          ? this.secondUserInfo.value
          : this.apiData.data.userInfo,
      )

      needUserInfo = computed(() => this.orderData.value.needUserInfo)

      //是否自动回填实名信息还是手动回填实名信息
      realNameInputType = computed(
        () => this.orderData.value.realNameInputType,
      )

      phoneNumber = ref('')

      name = ref('')

      realUserData = ref<any[]>([])

      // 渠道积分索引
      channelPointIndex = ref<number>(null as any)

      // 渠道积分抵扣
      channelPointDiscount = ref(0)

      // 消费金补贴抵扣
      showPoints = ref(false)

      // 消费金补贴数据
      pointsData = ref<PointsDataType>({})
      // 确认选择渠道积分
      handleChannelPointConfirm = (item: any) => {
        this.channelPointDiscount.value = +item.subAmount
      }

      pickCouponParams = computed<XPickCouponParams>(() => ({
        goodsIdList: this.preOrderData.value.orderInfo.reduce<any[]>(
          (res, merchant) => {
            res.push(
              ...merchant.commodityInfo.map(goods =>
                JSON.stringify({
                  id: goods.resourceId,
                  name: goods.commodityName,
                  price: goods.unitPrice,
                  count: goods.count,
                  totalAmt: mall.calculator.sub(
                    goods.totalPrice,
                    goods.discountActivityAmount,
                    this.dcdDiscountAmount.value,
                  ),
                  superimposeDiscountType:
                    this.preOrderData.value.discountItems?.[0]?.type || null,
                  categoryId: goods.categoryId,
                }),
              ),
            )
            return res
          },
          [],
        ),
        amt: this.preOrderData.value.orderAmount,
        discountedAmt: mall.calculator.add(
          ...(this.preOrderData.value.discountItems || []).map(
            item => item.amount,
          ),
        ),
        businessType: this.preOrderData.value.businessType,
        unitOrgCode: this.preOrderData.value.unitOrgCode,
      }))

      // 选择消费金的参数
      pickPointsParams = computed(() => ({
        orderDiscountAmt: this.payAmount.value,
        merchantId:
          this.preOrderData.value.unitOrgCode[0] ||
          this.preOrderData.value.unitOrgCode,
      }))

      pickCouponResult = ref<XPickCouponResult>({} as any)

      dcdDiscountAmount = computed(() => {
        if (!this.isDcd.value) return 0
        const dcdActivity = {
          count:
            this.preOrderData.value.orderInfo[0].commodityInfo[0]
              .integralActivity.initLimitCount,
          ...this.preOrderData.value.orderInfo[0].commodityInfo[0]
            .integralActivity,
        }
        return mall.calculator.mul(
          dcdActivity.count,
          dcdActivity.discountAmount,
        )
      })

      payAmount = computed(() => {
        try {
          return mall.calculator.sub(
            // 订单金额
            _ => _.mul(this.goodsData.value.unitPrice, this.count.value),

            // 减去优惠券金额
            this.pickCouponResult.value.discountedAmt || 0,

            // 减去折扣优惠金额
            _ =>
              _.add(
                ...(this.preOrderData.value.discountItems || []).map(
                  item => item.amount,
                ),
              ),

            // 减去渠道积分抵扣金额
            this.channelPointDiscount.value,

            // 减去多彩豆优惠
            this.dcdDiscountAmount.value,
          )
        } catch {
          return 0
        }
      })

      showMoney = computed(() => {
        return mall.calculator.sub(
          this.payAmount.value,
          this.pointsData.value.integralDiscountAmt ?? 0,
        )
      })

      useStore = ref<
        RequiredDeep<ApiMerchantStoreQueryWriteOffStoreListResponse>['list'][0]
      >({} as any)

      findUserIntegralCoupon = async () => {
        const env = await dcb.getEnv()
        // 安全检查
        if (
          !this.query.preOrderResponseData ||
          !this.query.preOrderResponseData.orderInfo ||
          this.query.preOrderResponseData.orderInfo.length === 0
        ) {
          console.warn(
            'preOrderResponseData or orderInfo is undefined or empty',
          )
          return
        }
        const data = await apiActivityVirtualActivityFindUserIntegralCoupon(
          {
            orderDiscountAmt: this.payAmount.value,
            merchantId:
              this.query.preOrderResponseData.orderInfo[0].unitOrgCode,
            paymentMethod: env.wechat ? 2 : 1,
          },
          {
            noErrorToast: true,
          },
        ).catch(() => [])

        if (
          data &&
          'userIntegralCouponList' in data &&
          Array.isArray(data.userIntegralCouponList)
        ) {
          this.pointsData.value = { ...data }
          this.showPoints.value = data.userIntegralCouponList.length > 0
        } else {
          this.pointsData.value = {}
          this.showPoints.value = false
        }
      }

      // 跳转实名规则
      handelerealNameRules(url: string) {
        dcb.navigateTo({
          url,
        })
      }

      //  初始化
      dataInit = async () => {
        this.secondUserInfo.value = await apiOrderOrderGetUserInfo()
        console.log('userInfo', this.userInfo)
      }
      // 实名认证
      gotoAuth = async () => {
        const userInfo = await dcb.requestRealNameAuthentication()
        console.log('userInfo', userInfo)
        // this.
        await this.dataInit()
      }

      handleUseStoreClick = () => {
        useBus.once('select', item => {
          this.useStore.value = item
        })
        navigateTo('BookMartUse', {
          id: this.orderData.value.merchantId,
        })
      }

      handleGroupBuyingRuleClick = () => {
        dcb.navigateTo({
          // @ts-ignore
          url: this.preOrderData.value.ruleUrl,
        })
      }

      handlePayPrepare = async () => {
        if (this.isExchange.value) {
          this.handlePayClick()
        } else {
          if (globalModel.state.inLove) {
            this.handlePayClick()
            return
          }
          const res = await requestPayment(this.preOrderData.value)
          if (res.channel === 'dcb') {
            this.handlePayClick()
          } else if (res.channel === 'qsxfj') {
            this.handlePointPayClick()
          } else if (res.channel === 'yzf') {
            this.handlePayClick(res.payType)
          }
        }
      }

      handlePayClick = (payType = globalModel.state.payType) => {
        submit(async $ => {
          if (
            !this.phoneNumber.value ||
            !isPossibleChineseMobilePhoneNumber(this.phoneNumber.value)
          ) {
            return $.fail('请输入正确的手机号')
          }

          if (
            this.preOrderData.value.hasChooseWriteOffStore &&
            !this.useStore.value.storeId
          ) {
            return $.fail('请选择核销门店')
          }

          // 渠道积分抵扣
          let channelPointPassword = undefined

          if (
            this.channelPointIndex.value != null &&
            !this.isExchange.value
          ) {
            const channelPointItem =
              this.preOrderData.value.channelActivityItems[
                this.channelPointIndex.value
              ]
            if (channelPointItem.needPassword) {
              channelPointPassword = await new Promise(resolve => {
                showSafeKeyboard({
                  type: channelPointItem.title,
                  config: channelPointItem.passwordKeyboard.keys,
                  onConfirm: resolve,
                })
              })
            }
            await new Promise<void>((resolve, reject) => {
              showDialog({
                title: `提示`,
                message: `确认使用【${channelPointItem.title}${channelPointItem.balanceUnit}】抵扣支付？`,
                confirmText: '确认',
                cancelText: '取消',
                onConfirm: resolve,
                onCancel: reject,
              })
            })
          }

          // 多彩豆检查
          const dcdCheckRes =
            this.isDcd.value && !this.isExchange.value
              ? await (ctx.$refs as any).dcd.check()
              : []

          $.start()

          if (this.needUserInfo.value && this.realNameInputType.value === 1) {
            const rule = yup.object({
              name: yup.string().label('姓名').required(),
              phone: yup
                .string()
                .label('联系电话')
                .required()
                .chineseMobilePhoneNumber(),
              idCard: yup
                .string()
                .label('身份证号')
                .required()
                .chineseIDCardNumber(),
            })
            for (const item of this.realUserData.value) {
              const { error } = rule.validatePlusSync(item)
              if (error) {
                return $.fail(error.message)
              }
            }
          }

          // @ts-ignore
          let payData = await (this.isGroupBuying.value
            ? apiGroupBuyingTradeTradeOrder
            : this.isSeckill.value
            ? apiTradeSecKillTradeSeckillTradeOrder
            : this.isExchange.value
            ? apiOrderExchangeGoodsExchangeGoodsTrade
            : apiTradeGeneralTradeTradeOrder)({
            preOrderId: this.preOrderData.value.preOrderId,
            consigneeName: this.name.value,
            consigneeTel: this.phoneNumber.value,
            consigneeAddress: {
              province: '',
              city: '',
              area: '',
              areaCode: '',
              detail: '',
              name: this.name.value,
              phoneNo: this.phoneNumber.value,
            },
            tradeOrderInfo: [
              {
                orderId: this.orderData.value.orderId,
                count: this.count.value,
                writeOffStoreId: this.useStore.value.storeId,
                integralCount: dcdCheckRes[0]?.quantity || 0,
                userInfoList: this.needUserInfo.value
                  ? this.realNameInputType.value === 1
                    ? this.realUserData.value
                    : []
                  : [],
              },
            ],
            couponId: this.pickCouponResult.value.couponId,
            discountAmount: this.pickCouponResult.value.discountedAmt || 0,
            password: channelPointPassword as any,
            payType: payType as any,
            openId: globalModel.state.openid,
          })
          Track.pushEvent({
            type: 'click',
            name: '提交订单',
            id: 'TiJiaoDinDan',
            extra:
              (payData && {
                // @ts-ignore
                order_id: payData.orderId,
                order_price: this.payAmount.value,
                commodity_id: this.preOrderData.value.orderInfo
                  .reduce<string[]>((res, merchant) => {
                    res.push(
                      ...merchant.commodityInfo.map(
                        goods => goods.commodityId,
                      ),
                    )
                    return res
                  }, [])
                  .join(','),
                commodity_name: this.preOrderData.value.orderInfo
                  .reduce<string[]>((res, merchant) => {
                    res.push(
                      ...merchant.commodityInfo.map(
                        goods => goods.commodityName,
                      ),
                    )
                    return res
                  }, [])
                  .join(','),
                original_price: this.preOrderData.value.orderAmount,
                present_price: this.payAmount.value,
                discount_price:
                  this.preOrderData.value.orderAmount - this.payAmount.value,
                submit_type: '立即支付',
              }) ||
              {},
          })
          if (this.isSeckill.value) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
              {
                retryDelay: 500,
              },
            )
            if (res.confirmState === 2) return $.fail(res.msg!)
            payData = res.result as any
          }

          if (this.isExchange.value) {
            $.success('兑换成功')
            redirectTo('OrderExchangeResult', {
              id: payData.orderId,
              sourceType: 1,
            })
            return
          }
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: {
                ...payData,
                unsupportedTips:
                  this.channelPointIndex.value != null
                    ? '账户余额不足'
                    : undefined,
              },
            })
            await wait(1000)
            if (this.isGroupBuying.value) {
              redirectTo('GroupBuyingPaySuccess', {
                // 拼单 ID
                // @ts-ignore
                id: payData.groupOrderId,
              })
            } else {
              // redirectTo('BookOrderIndex')
              redirectTo('OrderPayResult', {
                orderNo: payData.mallOrders[0]?.orderNo,
                goodType: 'book',
              })
            }
          } catch {
            if (this.isGroupBuying.value) {
              redirectTo('GroupBuyingOrderIndex', {
                active: 1,
              })
            } else {
              redirectTo('BookOrderIndex')
            }
          }
        })
      }

      handlePointPayClick = () => {
        submit(async $ => {
          if (
            !this.phoneNumber.value ||
            !isPossibleChineseMobilePhoneNumber(this.phoneNumber.value)
          ) {
            return $.fail('请输入正确的手机号')
          }
          if (this.payAmount.value === 0.01) {
            return $.fail('金额太低，不支持消费金方式')
          }

          $.start()

          // @ts-ignore
          const payData =
            await apiTradeGeneralActCouponTradeIntegralJoinTrade({
              preOrderId: this.preOrderData.value.preOrderId,
              consigneeName: this.name.value,
              consigneeTel: this.phoneNumber.value,
              consigneeAddress: {
                province: '',
                city: '',
                area: '',
                areaCode: '',
                detail: '',
                name: this.name.value,
                phoneNo: this.phoneNumber.value,
              },
              tradeOrderInfo: [
                {
                  orderId: this.orderData.value.orderId,
                  count: this.count.value,
                  writeOffStoreId: this.useStore.value.storeId,
                },
              ],
              couponId: this.pickCouponResult.value.couponId,
              discountAmount: this.pickCouponResult.value.discountedAmt || 0,
              payType: 12 as any,
              openId: undefined,
            })
          // @ts-ignore
          const payUrl = payData.targetUrl

          dcb.navigateTo({
            url: payUrl,
          })

          setTimeout(() => {
            redirectTo('BookOrderIndex')
          }, 60)
        })
      }
    },
)
